module.exports = __webpack_public_path__ + "9358b9d1db2f88fc18754a38b514dd08.png";